import React from "react";
import {FooterPage} from "../../AppCore/Component/Layout/FooterPage";
import styles from "../assets/css/page.css";

export const SuccessNotDownloadPDFComponent = ( ) => {

  return (
    <React.Fragment>
      {/* Agreement paragraph */}
      <div className="row agreement-text">
        <div className="col-lg-12 col-sm-12 col-xs-12" style={{marginBottom: '10%'}}>
          <p className={styles.description}>
            Thank you for contacting us, you have already signed the agreement before. If you want a copy of the agreement, please contact our sales team.
          </p>
        </div>
      </div>

      <div className={`row ${styles.footer}`}>
        <div className={"col-sm-12"}>
          <FooterPage />
        </div>
      </div>
    </React.Fragment>
  );
};




// WEBPACK FOOTER //
// ./src/modules/PartnerAgreement/Component/SuccessNotDownloadPDFComponent.js